import axios from 'axios'

const url = 'https://www.api.mathis-figuet.com/api/'

export default {
  login (credentials) {
    return axios
      .post(url + 'login/', credentials)
      .then(response => response.data)
  },
  register (credentials) {
    return axios
      .post(url + 'register/', credentials)
      .then(response => response.data)
  },
  getSecretContent () {
    return axios.get(url + 'secret-route/').then(response => response.data)
  }
}
